import type { ItemInterface } from 'common/services/Interfaces';

export const callCustomerLabEvents = (eventName, data) => {
  if (eventName === 'checkout_initiated') {
    beginCheckout(eventName, data);
  } else if (eventName === 'payment-screen') {
    addShippingInfo(eventName, data);
  } else if (eventName === 'payment-init') {
    addPaymentInfo(eventName, data);
  } else if (eventName === 'order-placed') {
    purchase(eventName, data);
  }
};
const createItemsBody = (cart) => {
  const items: ItemInterface[] = cart.items;
  return items?.map((item) => {
    /** If discount amount in properties exists
     * OR discount amount is null but discount %age exists
     */

    /** ends here */

    let itemEventPayload: any = {
      item_name: item.title,
      item_id: item.id,
      price: +item.final_line_price / 100,
      quantity: item.quantity,
    };

    itemEventPayload.discount_price = item?.properties['Discount Amount'] || '';
    itemEventPayload.discount_percentage = item?.properties['Discount Percentage'] || '';
    itemEventPayload.discount_applied =
      item?.properties?.['Discount Amount']?.length > 0 || item?.properties?.['Discount Percentage']?.length;
    if (itemEventPayload.discount_price) {
      itemEventPayload.mrp_price = +item.final_line_price / 100 + +itemEventPayload.discount_price;
    } else {
      if (itemEventPayload.discount_percentage) {
        itemEventPayload.mrp_price =
          +item.final_line_price / 100 / (100 - +itemEventPayload.discount_percentage?.replace('%', ''));
      } else {
        itemEventPayload.mrp_price = null;
      }
    }
    return itemEventPayload;
  });
};

const beginCheckout = (eventName, data) => {
  let dataObj = {
    ecommerce: {
      currency: 'INR',
      value: data?.commonAnalyticsData.cart_after_discount,
      coupon: data?.commonAnalyticsData?.coupon || data.commonAnalyticsData?.auto_coupon || '',
      items: createItemsBody(data?.cart),
      total_discount: data.priceBreakup?.total_discount + (+data.priceBreakup?.gift_card_and_reward || 0),
    },
  };
  triggerEvent(eventName, dataObj);
};

const addShippingInfo = (eventName, data) => {
  let dataObj = {
    phone_num: data?.phoneNumber,
    first_name: data?.userAddress?.firstname,
    last_name: data?.userAddress?.lastname,
    email: data?.userAddress?.email,
    city: data?.userAddress?.city,
    state: data?.userAddress?.state,
    pincode: data?.userAddress?.pincode,
    country: data?.userAddress?.country,
    ecommerce: {
      currency: 'INR',
      value: data?.commonAnalyticsData.cart_after_discount,
      coupon: data?.commonAnalyticsData?.coupon || data.commonAnalyticsData?.auto_coupon || '',
      items: createItemsBody(data?.cart),
      shipping_tier: data?.shippingMethod,
      total_discount: data.priceBreakup?.total_discount + (+data.priceBreakup?.gift_card_and_reward || 0),
    },
  };
  triggerEvent(eventName, dataObj);
};

const addPaymentInfo = (eventName, data) => {
  let dataObj = {
    phone_num: data?.phoneNumber,
    city: data?.userAddress?.city,
    state: data?.userAddress?.state,
    pincode: data?.userAddress?.pincode,
    country: data?.userAddress?.country,
    ecommerce: {
      currency: 'INR',
      value: data?.commonAnalyticsData.cart_after_discount,
      coupon: data?.commonAnalyticsData?.coupon || data.commonAnalyticsData?.auto_coupon || '',
      items: createItemsBody(data?.cart),
      shipping_tier: data?.shippingMethod,
      payment_type: data?.evt?.paymentMethod,
      total_discount: data.priceBreakup?.total_discount + (+data.priceBreakup?.gift_card_and_reward || 0),
    },
  };
  triggerEvent(eventName, dataObj);
};

const purchase = (eventName, data) => {
  let dataObj = {
    phone_num: data?.phoneNumber,
    first_name: data?.userAddress?.firstname,
    last_name: data?.userAddress?.lastname,
    email: data?.userAddress?.email,
    city: data?.userAddress?.city,
    state: data?.userAddress?.state,
    pincode: data?.userAddress?.pincode,
    country: data?.userAddress?.country,
    ecommerce: {
      currency: 'INR',
      value: data?.commonAnalyticsData.cart_after_discount,
      coupon: data?.commonAnalyticsData?.coupon || data.commonAnalyticsData?.auto_coupon || '',
      items: createItemsBody(data?.cart),
      shipping_tier: data?.shippingMethod,
      payment_type: data.paymentMethod,
      discount: data.priceBreakup?.total_discount + (+data.priceBreakup?.gift_card_and_reward || 0),
      subtotal: data.priceBreakup.line_items_subtotal,
      tax: 0,
      shipping: data?.commonAnalyticsData?.codCharges
        ? +data.shippingPrice + (+data?.commonAnalyticsData?.codCharges || 0)
        : data.shippingPrice,
      transaction_id: data.orderName,
      total_discount: data.priceBreakup?.total_discount + (+data.priceBreakup?.gift_card_and_reward || 0),
    },
  };
  triggerEvent(eventName, dataObj);
};

const triggerEvent = (eventName, eventData) => {
  window.dataLayer.push({ event: eventName, eventData });
};
